import React from 'react';
import { resolveStyle, StyleSheet, Text } from './base_components';

const styles = StyleSheet.create({
  label: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  text: { marginLeft: '0.5rem' },
});

type Props = {
  style?: any;
  textStyle?: any;
  className?: any;
  disabled?: boolean;
  text?: string;
  value: boolean;
  onChange: (boolean) => void;
};
export default function Checkbox(props: Props) {
  const { style, textStyle, text, value, className: extraClass } = props;
  function _onChange(e) {
    props.onChange(e.target.checked || false);
  }
  const { className, inlineStyle } = resolveStyle(
    [styles.label, style],
    extraClass
  );
  return (
    <label className={'base-component ' + className} style={inlineStyle}>
      <input
        type='checkbox'
        className='base-component-checkbox-input'
        checked={value}
        disabled={props.disabled}
        onChange={_onChange}
      />
      {text ? <Text style={[styles.text, textStyle]}>{text}</Text> : null}
    </label>
  );
}
